export const updatePanModalStyles = {
  paper: {
    margin: 0,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: '16px 16px 0 0',
    maxWidth: '100%',
    width: '100%',
  },
  container: {
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    pb: '24px',
    pt: '16px',
    px: '16px',
    borderRadius: '16px 16px 0 0',
    alignItems: 'flex-start',
  },
  header: {
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-start',
    width: '100%',
    flexShrink: 0,
  },
  titleWrap: {
    flex: '1 0 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },
  title: {
    alignSelf: 'stretch',
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: '"Noto Sans", sans-serif',
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: 1.6,
    letterSpacing: '0.15px',
  },
  subtitle: {
    alignSelf: 'stretch',
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: '"Noto Sans", sans-serif',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.15px',
  },
  closeButton: {
    width: 24,
    height: 24,
    display: 'block',
    cursor: 'pointer',
    flexShrink: 0,
    overflow: 'hidden',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'center',
    width: '100%',
    flexShrink: 0,
  },
  actionButton: {
    position: 'relative',
    borderRadius: '8px',
    width: '100%',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 22px',
    border: '1px solid rgba(0, 124, 191, 0.50)',
    '&:hover': {
      bgcolor: 'rgba(0, 124, 191, 0.04)',
    },
  },
  actionButtonInner: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  actionButtonText: {
    fontFamily: '"Noto Sans", sans-serif',
    fontWeight: 600,
    fontSize: '15px',
    color: '#007CBF',
    letterSpacing: '0.46px',
    lineHeight: '26px',
    whiteSpace: 'nowrap',
  },
};
